<template>
  <div class="modal com_modal2 fade" id="deleteFavoriteCompleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_c_check1.png" alt="" class="icon_c_check1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb0">ご指定のグループを削除しました</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1 wd2" data-bs-dismiss="modal">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>
